var IpcPthPadGeneratorData = require('./ipcPthPadGeneratorData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var EllipseData = require('../../../svg/ellipseData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var PthComponentAttribute = require('./pthComponentAttribute.js');
var IPCRules = require('../ipcRules');
var IPCPthFootprintCalculator = require('./pthCalculator.js');

var CrystalHC49Data = function(position, angle, init) {
    IpcPthPadGeneratorData.apply(this, arguments);
};

lib_core.inherit(CrystalHC49Data, IpcPthPadGeneratorData);
lib_core.JsonParser.registerClass(CrystalHC49Data, "CrystalHC49Data");

module.exports = CrystalHC49Data;

/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
CrystalHC49Data.prototype.getPads = function(absolutePositions) {
    var pads = [];
    var motif = this.getMotif();
    var hPitch = this.verticalPinPitch();
    var pad = motif.clone();
    //left pad
    pad.move(new lib_geometry.Coord(-0.5 * hPitch, 0));
    pads.push(pad);

    //right pad
    pad = motif.clone();
    pad.move(new lib_geometry.Coord(0.5 * hPitch, 0));
    pads.push(pad);

    this.updatePads(pads, absolutePositions);

    return pads;
};

CrystalHC49Data.prototype.getNormalBodyOutline = function(body) {
    var D = body.width;
    var E = body.height;

    var pathData = new PathData(new lib_geometry.Coord(-D / 2 + E / 2, -E / 2), IPCRules.silkscreenStrokeWidth);

    pathData.addObject(
        new PathObjectData(new lib_geometry.Coord(-D / 2 + E / 2, E / 2),
        PathType.ARC,
        new lib_geometry.Coord(-D / 2 + E / 2, -E / 2),
        new lib_geometry.Coord(-D / 2 + E / 2, E / 2),
        E/2,
        E/2)
    );

    pathData.addObject(new PathObjectData(new lib_geometry.Coord(D / 2 - E / 2, E / 2), PathType.LINE));

    pathData.addObject(
        new PathObjectData(new lib_geometry.Coord(D / 2 - E / 2, -E / 2),
        PathType.ARC,
        new lib_geometry.Coord(D / 2 - E / 2, E / 2),
        new lib_geometry.Coord(D / 2 - E / 2, -E / 2),
        E/2,
        E/2)
    );


    pathData.addObject(new PathObjectData(new lib_geometry.Coord(-D / 2 + E / 2, -E / 2), PathType.LINE));
    return pathData;
};

CrystalHC49Data.prototype.getAssemblyOutline = function(pads) {
    if (pads.length === 0) return;

    var body = this.getBodyForAssembly();
    return this.getNormalBodyOutline(body);
};

/**
 * Calculate silkscreen for selected component. Silkscreen is calculated from body and pads geometry.
 * @param  {array} pads Pads calculated from getPads() function.
 * @return {array} Array of silkscreen data
 */
CrystalHC49Data.prototype.getSilkscreen = function(pads) {
    if(pads.length === 0) return;

    var body = this.getBodyForSilkscreen();
    var leftPad = pads[0];

    var D = body.width;
    var E = body.height;

    var silkscreen = [];

    var topLineStart = new lib_geometry.Coord(-D / 2 + E / 2, E / 2);
    var topLineEnd = topLineStart.flipX();

    /*

    Case I
      XXXX   XXXXXXXXXXXX   XXXX
     X                          X
    X                             X
     X                          X
      XXXX   XXXXXXXXXXXX   XXXX


    Case II
       XXXXXXXXXXXX
     X              X

     X              X
       XXXXXXXXXXXX


    Case III [IGNORED]
          XXXXXXXXXXXX
     X                    X
    X                      X
    X                      X
     X                    X
          XXXXXXXXXXXX
    */


    var isSplittedLineWithArc = false; //case I
    var splittedLineWithArcStartX;
    var isSplittedLine = false; //case I
    var isSplittedArc = false; //case II
    var x1 = 0, x2 = 0; //left and right intersection x coords for top silkscreen line and pad intersection

    var x3 = 0; //top and bottom intersection x coord for pad and left circluar silkscreen intersection
    var y3 = 0; //top intersection's y coord for pad and left circluar silkscreen intersection

    var dx = 0; //distance between pad center and intersection point on pad along x axis
    var padSizeWithClearance;
    var clearance = IPCRules.silkscreenClearance;

    if(this.padShape() === PthComponentAttribute.padShapes["Round"]) {
        padSizeWithClearance = leftPad.getTopCopper().width() / 2 + clearance;
        dx = Math.sqrt(padSizeWithClearance * padSizeWithClearance - topLineStart.y * topLineStart.y);
    } else if(this.padShape() === PthComponentAttribute.padShapes["Square"]) {
        dx = padSizeWithClearance = leftPad.getTopCopper().width() / 2 + clearance;
    }

    //check for case I
    //ignore if line coord y is more than padSizeWithClearance
    if(topLineStart.y <= padSizeWithClearance) {
        x1 = leftPad.getPos().x - dx;
        x2 = leftPad.getPos().x + dx;

        //if top line's starting point is not on right side of pad
        if(topLineStart.x <= x2) {
            //top line needs to be splitted (case I: middle portion of top silkscreen)
            isSplittedLine = true;

            //if top line's starting point is on left side of pad
            if(topLineStart.x <= x1) {
                //start line needs to be splitted and needs to be drawn with left circular silkscreen (case I: left silkscreen part)
                isSplittedLineWithArc = true;
                splittedLineWithArcStartX = x1;
            }

            //update top line's start and end coordinate
            topLineStart.x = x2;
            topLineEnd = topLineStart.flipX();
        }
    }

    //if case I is not satisfied check for case II
    if(!isSplittedLine) {
        //check intersections between pad and silkscreen circular section
        var arcCenterX = -D / 2 + E / 2;
        var d = leftPad.getTopCopper().getPos().distance(new lib_geometry.Coord(arcCenterX, 0));

        if(this.padShape() === PthComponentAttribute.padShapes["Round"]) {
            //do not intersect if either (d > r0 + r1) or (d < |r0 - r1|)
            if(d <= padSizeWithClearance + E / 2 && d >= Math.abs(padSizeWithClearance - E / 2)) {
                //http://paulbourke.net/geometry/circlesphere/
                var a = (padSizeWithClearance * padSizeWithClearance - E*E/4 + d*d) / (2*d);
                x3 = leftPad.getTopCopper().getPos().x + a * (arcCenterX - leftPad.getTopCopper().getPos().x) / d; //x-coord of intersection
                y3 = Math.sqrt(padSizeWithClearance * padSizeWithClearance - a*a); //y-coord of top intersection

                //conside only intersection points on visible circular silkscreen
                if(x3 < arcCenterX) {
                    isSplittedArc = true;
                }
            }
        } else if(this.padShape() === PthComponentAttribute.padShapes["Square"]) {
            //distance between top right corner of square pad and circular silkscreen center
            var d1 = new lib_geometry.Coord(leftPad.getTopCopper().getPos().x + padSizeWithClearance, leftPad.getTopCopper().getPos().y + padSizeWithClearance).distance(new lib_geometry.Coord(arcCenterX, 0));

            //distance between top left corner of square pad and circular silkscreen center
            var d2 = new lib_geometry.Coord(leftPad.getTopCopper().getPos().x - padSizeWithClearance, leftPad.getTopCopper().getPos().y + padSizeWithClearance).distance(new lib_geometry.Coord(arcCenterX, 0));

            //if both corner are outside of circle
            if(d1 > E/2 && d2 > E/2) {
                if(d <= padSizeWithClearance + E / 2) { //square pad intersects with circle
                     //square pad right edge intersects
                    /*
                                   XXXXX
                        +-------+ X
                        |       |X
                        |       |
                        |       |X
                        +-------+ X
                                   XXXXX

                     */
                    x3 = leftPad.getTopCopper().getPos().x + padSizeWithClearance;
                    y3 = Math.sqrt(E*E/4 - (d - padSizeWithClearance) * (d - padSizeWithClearance));
                }
            } else if(E/2 > d1 && E/2 < d2) { //if top edge intersects with circle (one corner is outside of circle)
                /*
                             XXXXXXX
                           XX
                          X
                         X
                    +-------+
                    |       |
                    |       |
                    |       |
                    +-------+
                         X
                          X
                           XX
                             XXXXXXX

                 */
                var a = d - Math.sqrt(E*E/4 - padSizeWithClearance * padSizeWithClearance);
                x3 = leftPad.getTopCopper().getPos().x + a * (arcCenterX - leftPad.getTopCopper().getPos().x) / d; //x-coord of intersection
                y3 = padSizeWithClearance; //y-coord of top intersection
            }

            //conside only intersection points on visible circular silkscreen
            if(x3 < arcCenterX) {
                isSplittedArc = true;
            }
        }
    }

    //DRAW PART
    if(isSplittedLine) { //case I
        //draw splitted top and bottom line
        if(topLineStart.x < topLineEnd.x) {
            var pathData = new PathData(topLineStart, IPCRules.silkscreenStrokeWidth);
            pathData.addObject(new PathObjectData(topLineEnd, PathType.LINE));
            silkscreen.push(pathData);

            pathData = pathData.clone();
            pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
            silkscreen.push(pathData);
        }

        //draw remaining line with arcs on left and right side if applicable
        if(isSplittedLineWithArc) {
            var pathData = new PathData(new lib_geometry.Coord(splittedLineWithArcStartX, -E / 2), IPCRules.silkscreenStrokeWidth);
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(-D / 2 + E / 2, -E / 2), PathType.LINE));
            pathData.addObject(
                new PathObjectData(new lib_geometry.Coord(-D / 2 + E / 2, E / 2),
                PathType.ARC,
                new lib_geometry.Coord(-D / 2 + E / 2, -E / 2),
                new lib_geometry.Coord(-D / 2 + E / 2, E / 2),
                E/2,
                E/2)
            );
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(splittedLineWithArcStartX, E / 2), PathType.LINE));
            silkscreen.push(pathData);

            pathData = pathData.clone();
            pathData.flip(new lib_geometry.Line(lib_geometry.Line.VER, new lib_geometry.Coord(0, 0)));
            silkscreen.push(pathData);
        }
    } else if(isSplittedArc) {//case II
        var pathData = new PathData(new lib_geometry.Coord(x3, y3), IPCRules.silkscreenStrokeWidth);
            pathData.addObject(
                new PathObjectData(new lib_geometry.Coord(-D / 2 + E / 2, E / 2),
                PathType.ARC,
                new lib_geometry.Coord(x3, y3),
                new lib_geometry.Coord(-D / 2 + E / 2, E / 2),
                E/2,
                E/2)
            );

            pathData.addObject(new PathObjectData(new lib_geometry.Coord(D / 2 - E / 2, E / 2), PathType.LINE));
            pathData.addObject(
                new PathObjectData(new lib_geometry.Coord(x3, y3).flipX(),
                PathType.ARC,
                new lib_geometry.Coord(D / 2 - E / 2, E / 2),
                new lib_geometry.Coord(x3, y3).flipX(),
                E/2,
                E/2)
            );

            silkscreen.push(pathData);

            pathData = pathData.clone();
            pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
            silkscreen.push(pathData);
    } else {
        silkscreen.push(this.getNormalBodyOutline(body));
    }

    return silkscreen;
};
